/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OwnershipSubjectDto } from './ownershipSubjectDto.model';


export interface OwnershipDto { 
    endDate?: string;
    id?: number;
    katuzeKod?: number;
    lv?: number;
    opsubId?: number;
    podilCitatel?: number;
    podilJmenovatel?: number;
    startDate?: string;
    subject?: OwnershipSubjectDto;
    typravKod?: string;
    typravNazev?: string;
}

